import React, { useState, useRef, useEffect, MutableRefObject } from "react";
import { useParams } from "react-router-dom";
import RoomNotFoundPage from "./RoomNotFoundPage";
import RoomPage from "./RoomPage";
import { API_URL } from "../constants/config";

type RoomState = "loading" | "room_found" | "room_not_found";

export default function RoomRouter() {
  const { accessCode } = useParams();
  const [roomState, setRoomState] = useState<RoomState>("loading");
  const ws = useRef<WebSocket>();

  useEffect(() => {
    ws.current = new WebSocket(
      accessCode
        ? `${API_URL}/room/${accessCode}` // join existing room
        : `${API_URL}/room` // start new room
    );

    ws.current.onopen = () => {
      // Websocket session opened successfully
      setRoomState("room_found");
    };

    ws.current.onclose = () => {
      // Websocket session couldn't open, this indicates that the access code is invalid
      setRoomState("room_not_found");
    };

    return () => {
      ws.current?.close();
    };
  }, [accessCode]);

  switch (roomState) {
    case "loading":
      return null;
    case "room_found":
      return <RoomPage {...{ initialAccessCode: accessCode, ws: ws as MutableRefObject<WebSocket> }} />;
    case "room_not_found":
      return <RoomNotFoundPage />;
  }
}
